import _ from "lodash";
import { AnimatePresence } from "framer-motion";

import { getCurrentDepartment } from "../../../services/functions";
import { useMenu } from "../../../store/global/useMenu";

import { LinkProvider } from "./link-context";
import { LinkItem } from "./link-item";


export function LinkRoot(props) {
  // const item = useMenu(st => st.data.itens[props.name])
  const isHidden = _.castArray(props.hidden).includes(getCurrentDepartment())


  return (
    <AnimatePresence initial={false} mode="popLayout">
      {!isHidden && (
        <LinkProvider {...props}>
          <LinkItem {...props} />
        </LinkProvider>
      )}
    </AnimatePresence>
  );
}
